<template>
  <span>
    <v-dialog max-width="1000px" persistent :value="true">
      <v-card>
        <v-card-title>
          <span class="headline">{{ $t("travelService.orderCar") }}</span>
        </v-card-title>
        <v-card-text>
          <v-form lazy-validation ref="form" v-model="formValid">
            <fieldset class="custom-fieldset">
              <order-user-select
                :value.sync="contextModel.travelServiceOrderItemPassengers[0]"
                :birth-date-required="$store.getters['userProperties'].system_settings.travel_service_car_insurance === insuranceTypeID.INSURANCE_ADD"
              />
            </fieldset>

            <v-row dense>
              <v-col class="px-2" cols="12" sm="6">
                <v-select
                  :items="carClass"
                  :label="$t('travelService.carClass') + '*'"
                  :rules="[validatorIsRequired]"
                  v-model="contextModel.travelServiceOrderItemCar.car_class"
                />
              </v-col>
              <v-col class="px-2" cols="12" sm="6">
                <location-ajax-select
                  :label="$t('travelService.pickupPlace') + '*'"
                  :placeholder="$t('travelService.enterCountry')"
                  :rules="[v => (v != null && v.length > 0) || $t('global.error.required')]"
                  :select-model.sync="contextModel.travelServiceOrderItemCar.start_place_id"
                />
              </v-col>
              <v-col class="px-2" cols="12" sm="6">
                <date-picker
                  :label="$t('travelService.pickupDate') + '*'"
                  :max="contextModel.travelServiceOrderItemCar.end_date"
                  :model.sync="contextModel.travelServiceOrderItemCar.start_date"
                  :rules="[validatorIsRequired, validatorIsFutureDate]"
                />
              </v-col>
              <v-col class="px-2" cols="12" sm="6">
                <time-picker
                  :label="$t('travelService.pickupTime')"
                  :model.sync="contextModel.travelServiceOrderItemCar.start_time"
                  :placeholder="$t('travelService.any')"
                  prepend-icon=""
                />
              </v-col>
              <v-col class="px-2" cols="12" sm="6">
                <date-picker
                  :label="$t('travelService.returnCarDate') + '*'"
                  :min="contextModel.travelServiceOrderItemCar.start_date"
                  :model.sync="contextModel.travelServiceOrderItemCar.end_date"
                  :rules="[validatorIsRequired, validatorIsFutureDate]"
                />
              </v-col>
              <v-col class="px-2" cols="12" sm="6">
                <time-picker
                  :label="$t('travelService.returnCarTime')"
                  :model.sync="contextModel.travelServiceOrderItemCar.end_time"
                  :placeholder="$t('travelService.any')"
                  prepend-icon=""
                />
              </v-col>
              <v-col class="px-2" cols="12" sm="6">
                <v-checkbox :label="$t('travelService.returnDifferentPlace')" @click.native="cleanEndLocation" v-model="otherEndLocation" />
              </v-col>
              <v-col class="px-2" cols="12" sm="6" v-if="otherEndLocation">
                <location-ajax-select
                  :label="$t('travelService.returnCarPlace') + '*'"
                  :placeholder="$t('travelService.enterCountry')"
                  :rules="[validatorIsRequired]"
                  :select-model.sync="contextModel.travelServiceOrderItemCar.end_place_id"
                />
              </v-col>
              <v-col class="px-2" cols="12" sm="6">
                <cost-centre-select :value.sync="contextModel.cost_centre" />
              </v-col>

              <v-col class="px-2" cols="12">
                <v-text-field :label="$t('global.comment')" v-model="contextModel.comment" />
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn @click.native="cancel" color="blue darken-1" text>{{ $t("global.cancel") }}</v-btn>
          <v-btn :disabled="!formValid" @click.native="save" color="blue darken-1" text>Ok</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
import LocationAjaxSelect from "../CustomInputComponents/LocationAjaxSelect";
import DatePicker from "../CustomInputComponents/DatePicker";
import TimePicker from "../CustomInputComponents/TimePicker";
import CostCentreSelect from "./CostCentreSelect";
import OrderUserSelect from "./OrderUserSelect";
import { allCarTypes } from "../../staticData/TravelServiceTypes";
import moment from "moment";
import vue from "../../main";
import { insuranceTypeID } from "../../staticData/TravelServiceTypes";

export default {
  name: "OrderServiceCar",
  components: {
    OrderUserSelect,
    CostCentreSelect,
    TimePicker,
    DatePicker,
    LocationAjaxSelect
  },
  data: () => ({
    formValid: true,
    otherEndLocation: false,
    contextModel: null,
    insuranceTypeID
  }),
  watch: {
    contextModel: {
      deep: true,
      handler() {
        if (JSON.stringify(this.contextModel) !== JSON.stringify(this.editedTravelServiceOrderItem)) {
          this.updateVuexState();
        }
      }
    },
    editedTravelServiceOrderItem: {
      deep: true,
      handler() {
        this.load();
      }
    }
  },
  computed: {
    carClass: allCarTypes,
    editedTravelServiceOrderItem() {
      return this.$store.state.TravelService.editedTravelServiceItem;
    }
  },
  methods: {
    validatorIsRequired(v) {
      return (v != null && v.length > 0) || this.$t("global.error.required");
    },
    validatorIsFutureDate(v) {
      return (
        moment(v)
          .endOf("day")
          .isAfter(moment()) || vue.$t("global.error.dateLaterThanNow")
      );
    },
    updateVuexState() {
      this.$store.commit("TravelService/setEditedTravelServiceItem", this.contextModel);
    },
    cancel() {
      this.$store.commit("TravelService/setEditedTravelServiceItem", null);
      this.$store.commit("TravelService/setOldTravelServiceItem", null);

      // this.contextModel.is_insurance = parseInt(this.$store.getters["userProperties"].system_settings.travel_service_car_insurance) === 1;
      this.$refs.form.resetValidation();
    },
    cleanEndLocation() {
      if (!this.otherEndLocation) {
        this.contextModel.travelServiceOrderItemCar.end_place_id = null;
      }
    },
    load() {
      this.contextModel = JSON.parse(JSON.stringify(this.editedTravelServiceOrderItem));
      this.otherEndLocation = this.contextModel.travelServiceOrderItemCar.end_place_id !== null;
    },
    save() {
      if (this.$refs.form.validate()) {
        this.$store.dispatch("TravelService/saveEditedServiceItem");
      }
    }
  },
  created() {
    //this.contextModel.is_insurance = parseInt(this.$store.getters["userProperties"].system_settings.travel_service_car_insurance) === 1;
    this.load();
  }
};
</script>

<style scoped></style>
